module.exports = __webpack_public_path__ + "img/wheels.b3082a48.png";